import { useDispatch, useSelector } from "react-redux";
import {
    getIleggelse as getIleggelseAction,
    putIleggelserSettKlarTilIne as putIleggelserSettKlarTilIneAction,
} from "../../../../actions/ileggelserActions";
import SendTilIne from "../../../Common/Detalj/SendTilIne";

export default function SendTilIneContainer() {
  const ileggelse = useSelector((state) => state.ileggelse);
  const dispatch = useDispatch();

  const getIleggelse = (id) => dispatch(getIleggelseAction(id));
  const putIleggelserSettKlarTilIne = () =>
    dispatch(putIleggelserSettKlarTilIneAction(ileggelse.id))
      .then(() => getIleggelse(ileggelse.id))
      .catch();

  if (!ileggelse.isMakulert && ileggelse.isFeiletKemner) {
    return (
      <SendTilIne
        ileggelse={ileggelse}
        putIleggelserSettKlarTilIne={putIleggelserSettKlarTilIne}
        getIleggelse={getIleggelse}
      />
    );
  }
  return <span />;
}
